export const REQUEST_MASTER_FAQS = "REQUEST_MASTER_FAQS";
export const SET_MASTER_FAQS = "SET_MASTER_FAQS";
export const ERROR_GET_MASTER_FAQS = "ERROR_GET_MASTER_FAQS";

export const REQUEST_MASTER_FAQS_CATEGORIES = "REQUEST_MASTER_FAQS_CATEGORIES";
export const SET_MASTER_FAQS_CATEGORIES = "SET_MASTER_FAQS_CATEGORIES";
export const ERROR_GET_MASTER_FAQS_CATEGORIES = "ERROR_GET_MASTER_FAQS_CATEGORIES";

export const REQUEST_CREATE_MASTER_FAQS = "REQUEST_CREATE_MASTER_FAQS";
export const SUCCESS_CREATE_MASTER_FAQS = "SUCCESS_CREATE_MASTER_FAQS";
export const ERROR_CREATE_MASTER_FAQS = "ERROR_CREATE_MASTER_FAQS";

export const REQUEST_UPDATE_MASTER_FAQS = "REQUEST_UPDATE_MASTER_FAQS";
export const SUCCESS_UPDATE_MASTER_FAQS = "SUCCESS_UPDATE_MASTER_FAQS";
export const ERROR_UPDATE_MASTER_FAQS = "ERROR_UPDATE_MASTER_FAQS";

export const REQUEST_DELETE_MASTER_FAQS = "REQUEST_DELETE_MASTER_FAQS";
export const SUCCESS_DELETE_MASTER_FAQS = "SUCCESS_DELETE_MASTER_FAQS";
export const ERROR_DELETE_MASTER_FAQS = "ERROR_DELETE_MASTER_FAQS";

export const SET_MESSAGE_MASTER_FAQS = "SET_MESSAGE_MASTER_FAQS";